<template>
  <div>
    <footer class="site-footer">
      <div class="site-footer-bottom">
        <div class="container-herohire">
          <div class="site-footer-inner">
            <div class="brand footer-brand">
              <a href="#">
                <img
                    src="@/assets/herohire-logo.png"
                    alt="Hero Hire logo"
                    width="100">
              </a>
              <a
                  href="https://koffeestudios.com"
                  class="margin-left-2 margin-top-1">
                <img
                    src="@/assets/koffee_logo_primary.png"
                    alt="Koffee Studios logo"
                    width="100">
              </a>
            </div>
            <ul class="footer-links list-reset">
              <li>
                <router-link to="home">
                  Home
                </router-link>
              </li>
              <li>
                <router-link to="privacy-policy">
                  Privacy Policy
                </router-link>
              </li>
              <li>
                <router-link to="dashboard">
                  Dashboard
                </router-link>
              </li>
<!--              <li>-->
<!--                <router-link to="payments">-->
<!--                  Payments-->
<!--                </router-link>-->
<!--              </li>-->
            </ul>
            <ul class="footer-social-links list-reset">
              <li>
                <a href="https://www.facebook.com/HeroHireApp">
                  <span class="screen-reader-text">Facebook</span>
                  <svg
                      width="16"
                      height="16"
                      xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M6.023 16L6 9H3V6h3V4c0-2.7 1.672-4 4.08-4 1.153 0 2.144.086 2.433.124v2.821h-1.67c-1.31 0-1.563.623-1.563 1.536V6H13l-1 3H9.28v7H6.023z"
                        fill="#FFF"/>
                  </svg>
                </a>
              </li>
            </ul>
            <ul class="footer-links list-reset">
              <p>
                You are currently logged in as <span class="text-primary">{{ user.data.email }}</span>
                (<a class="error--text" @click="logout">
                Logout
              </a>)
              </p>
            </ul>
            <div class="footer-copyright">
              &copy; {{ date }} Koffee Studios, all rights reserved
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: "DashboardFooter",
  data() {
    return {
      date: new Date().getFullYear(),
      userEmail: ''
    }
  },
  methods: {
    logout() {
      this.$firebase
          .auth()
          .signOut()
          .then(() => this.$router.push('/'))
    }
  },
  computed: {
    ...mapGetters({
      user: "user"
    })
  }
}
</script>

<style lang="scss" scoped>
.site-footer {
  height: 295px;
  bottom: 0;
  position: absolute;
  width: 100%;
}
</style>
